import React from "react";

export type StatTableItem = {
  value: string;
  label: string;
  highlight?: boolean;
};

type Props = {
  items: StatTableItem[];
};

const ElectionStatsTable = ({ items }: Props) => {
  return (
    <table className="v26-stats-table">
      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            <td className={"val" + (item.highlight ? " highlight" : "")}>{item.value}</td>
            <td className="label">{item.label}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ElectionStatsTable;
